import { useState } from "react";
import * as motion from "motion/react-client";
import { Box, BoxProps, Flex } from "@/ui";

type Props = {
  id: string | null;
  steps: string[];
};

const tabStyle: BoxProps = {
  borderRadius: "32",
  h: "6"
};

export const useStepCounter = () => {
  const [stepId, setStepId] = useState<string | null>(null);

  const stepsList = ["camera-name", "camera-customization", "camera-usage"];
  return {
    stepId,
    handleStepChange: (stepId: string) => setStepId(stepId),
    stepsList
  };
};

export default function StepCounter({ id, steps }: Props) {
  const showCounter = id !== null && steps.includes(id);

  return (
    <motion.div
      animate={{ opacity: showCounter ? 1 : 0 }}
      transition={{ duration: 0.3, delay: showCounter ? 0.3 : 0 }}
      style={{
        position: "absolute",
        top: "72px",
        left: "32px",
        right: "32px",
        zIndex: 1,
        pointerEvents: showCounter ? "auto" : "none"
      }}
    >
      {showCounter && (
        <Flex w="100%" columnGap="1rem">
          {steps.map((item, i) => (
            <motion.div style={{ flex: 1 }} key={i} initial={false}>
              <Box pos="relative">
                <Box {...tabStyle} bg="outline-variant" zIndex={0} />
                {item === id && (
                  <Box
                    as={motion.div}
                    layoutId="underline"
                    zIndex={1}
                    position="absolute"
                    top={0}
                    bottom={0}
                    left={0}
                    right={0}
                    bg="primary"
                    {...tabStyle}
                  />
                )}
              </Box>
            </motion.div>
          ))}
        </Flex>
      )}
    </motion.div>
  );
}
